// Import Libs and Handlers
import React from 'react';
import { AppRender } from '../handlers/reactHandlers/render';
import { injectStyle } from '../handlers/shared/injectStyle';
import { initComponentInstanceIndexMap } from '../handlers/shared/instanceMap';
import { selectVersion } from '../handlers/shared/selectVersion';

// Import Components
import Image from '../libraries/base/components/Image'

// Import Plugins
import MaxWidth from '../libraries/base/plugins/MaxWidth';
import Share from '../libraries/base/plugins/Share'

// Import Actions
import OpenURL from '../libraries/base/actions/OpenURL'

let ReactDOMServer;
if(process.env.SSR) {
  // TODO: Remove
  require('@babel/polyfill/noConflict');
  ReactDOMServer = require('react-dom/server');
}

// Global Style
injectStyle(`body {
	border: 1px none #161616 !important;
background-color: #ffffff !important;
background-repeat: repeat-y !important;
background-size: auto !important;
background-position: center top !important;
}`, '__impage_injected-global-styles');

// Auto Inject Style
injectStyle(``, '__impage_injected-component-styles');

// Global Data
const meta = {
    "title": "2021初一春季系统班",
    "desc": "2021春季系统班开班啦！一起进步吧~",
    "start": new Date('Mon Jan 18 2021 17:10:55 GMT+0800 (China Standard Time)'),
    "end": new Date('Tue Jun 01 2021 17:10:55 GMT+0800 (China Standard Time)'),
    "actId": 5251,
    "actKey": "21c1",
    "containerType": "web",
    "isTemplate": false,
    "isEditor": false,
    "isTestEnv": false
};

const _global = {
    "jumpUrl": ""
};

// Inject JIMU_Vars
if (typeof window !== 'undefined') {
  if(!window['JIMU_VARS']){
    Object.defineProperty(window, 'JIMU_VARS', {
      value: {
    "key": "21c1",
    "actStartTime": "2021-01-18T09:10:55.000Z",
    "actEndTime": "2021-06-01T09:10:55.000Z",
    "isJimu": false,
    "jumpUrl": ""
},
      writable: false,
      configurable: false,
    });
  }

  // Inject Global
  if(!window['VISION']){
    Object.defineProperty(window, 'VISION', {
      value: { meta, global: _global },
      writable: false,
      configurable: false,
    });
  }
}

// Actions
const actions = {
    "1": {
        "action": OpenURL,
        "id": 1,
        "projId": 1,
        "projKey": "base",
        "name": "OpenURL",
        "info": {
            "name": "跳转URL",
            "author": "elliothu"
        }
    }
};

// Components
const components = {
    "5": {
        "component": Image,
        "id": 5,
        "projId": 1,
        "projKey": "base",
        "name": "Image",
        "info": {
            "name": "图片",
            "desc": "图片组件",
            "author": "elliothu"
        },
        "__implementHotArea": true
    }
};

// Plugin
const plugins = {
    "5": {
        "plugin": Share,
        "id": 5,
        "name": "Share",
        "info": {
            "name": "分享配置",
            "desc": "配置分享内容，监听分享事件，支持微信 & 手Q",
            "author": "elliothu"
        }
    },
    "9": {
        "plugin": MaxWidth,
        "id": 9,
        "name": "MaxWidth",
        "info": {
            "name": "页面宽度限制",
            "desc": "设置页面最大宽度，让页面快速适配 PC",
            "author": "elliothu"
        }
    }
};

// InstanceMap { [versionId]: { componentInstances: [], pluginInstances: [] } }
const instanceVersionMap = {
    "v0fa327e": {
        "componentInstances": [
            {
                "key": 0,
                "component": components['5'],
                "data": {
                    "src": "//cdn.vision.qq.com/prod/imgs/static/static_1610961281384.jpg",
                    "hotAreas": []
                },
                "style": {},
                "commonStyle": {
                    "maxWidth": "100%",
                    "margin": "0px auto 0px auto",
                    "cursor": "default",
                    "border": "1px none #161616"
                },
                "wrapperStyle": {
                    "backgroundColor": "transparent",
                    "backgroundRepeat": "repeat-y",
                    "backgroundSize": "auto",
                    "backgroundPosition": "center top"
                },
                "fixedWrapperStyle": {},
                "actions": []
            },
            {
                "key": 1,
                "component": components['5'],
                "data": {
                    "src": "//cdn.vision.qq.com/prod/imgs/static/static_1610961318554.jpg",
                    "hotAreas": [
                        {
                            "key": 20,
                            "position": {
                                "x": 29.333333333333332,
                                "y": 91.9620253164557
                            },
                            "size": {
                                "width": 41.6,
                                "height": 5.3164556962025316
                            },
                            "actions": [
                                {
                                    "key": 23,
                                    "action": actions['1'],
                                    "data": {
                                        "newTable": false,
                                        "deliverParams": true,
                                        "url": "https://fudao.qq.com/course_break_article.html?_bid=2379&_wv=2147484673&article_id=978&fr=h5"
                                    },
                                    "trigger": "__impage_action_trigger_click",
                                    "target": null
                                }
                            ]
                        }
                    ]
                },
                "style": {},
                "commonStyle": {
                    "maxWidth": "100%",
                    "margin": "0px auto 0px auto",
                    "cursor": "default",
                    "border": "1px none #161616"
                },
                "wrapperStyle": {
                    "backgroundColor": "transparent",
                    "backgroundRepeat": "repeat-y",
                    "backgroundSize": "auto",
                    "backgroundPosition": "center top"
                },
                "fixedWrapperStyle": {},
                "actions": []
            },
            {
                "key": 2,
                "component": components['5'],
                "data": {
                    "src": "//cdn.vision.qq.com/prod/imgs/static/static_1610961432416.jpg",
                    "hotAreas": [
                        {
                            "key": 21,
                            "position": {
                                "x": 34,
                                "y": 83.23809523809523
                            },
                            "size": {
                                "width": 31.733333333333334,
                                "height": 7.6190476190476195
                            },
                            "actions": [
                                {
                                    "key": 22,
                                    "action": actions['1'],
                                    "data": {
                                        "newTable": false,
                                        "deliverParams": true,
                                        "url": "https://oed.qq.com/mm8m23?fr=h5"
                                    },
                                    "trigger": "__impage_action_trigger_click",
                                    "target": null
                                }
                            ]
                        }
                    ]
                },
                "style": {},
                "commonStyle": {
                    "maxWidth": "100%",
                    "margin": "0px auto 0px auto",
                    "cursor": "default",
                    "border": "1px none #161616"
                },
                "wrapperStyle": {
                    "backgroundColor": "transparent",
                    "backgroundRepeat": "repeat-y",
                    "backgroundSize": "auto",
                    "backgroundPosition": "center top"
                },
                "fixedWrapperStyle": {},
                "actions": []
            },
            {
                "key": 3,
                "component": components['5'],
                "data": {
                    "src": "//cdn.vision.qq.com/prod/imgs/static/static_1610961502091.jpg",
                    "hotAreas": []
                },
                "style": {},
                "commonStyle": {
                    "maxWidth": "100%",
                    "margin": "0px auto 0px auto",
                    "cursor": "default",
                    "border": "1px none #161616"
                },
                "wrapperStyle": {
                    "backgroundColor": "transparent",
                    "backgroundRepeat": "repeat-y",
                    "backgroundSize": "auto",
                    "backgroundPosition": "center top"
                },
                "fixedWrapperStyle": {},
                "actions": []
            },
            {
                "key": 4,
                "component": components['5'],
                "data": {
                    "src": "//cdn.vision.qq.com/prod/imgs/static/static_1610961524920.jpg",
                    "hotAreas": []
                },
                "style": {},
                "commonStyle": {
                    "maxWidth": "100%",
                    "margin": "0px auto 0px auto",
                    "cursor": "default",
                    "border": "1px none #161616"
                },
                "wrapperStyle": {
                    "backgroundColor": "transparent",
                    "backgroundRepeat": "repeat-y",
                    "backgroundSize": "auto",
                    "backgroundPosition": "center top"
                },
                "fixedWrapperStyle": {},
                "actions": []
            },
            {
                "key": 5,
                "component": components['5'],
                "data": {
                    "src": "//cdn.vision.qq.com/prod/imgs/static/static_1610961670460.jpg",
                    "hotAreas": []
                },
                "style": {},
                "commonStyle": {
                    "maxWidth": "100%",
                    "margin": "0px auto 0px auto",
                    "cursor": "default",
                    "border": "1px none #161616"
                },
                "wrapperStyle": {
                    "backgroundColor": "transparent",
                    "backgroundRepeat": "repeat-y",
                    "backgroundSize": "auto",
                    "backgroundPosition": "center top"
                },
                "fixedWrapperStyle": {},
                "actions": []
            },
            {
                "key": 6,
                "component": components['5'],
                "data": {
                    "src": "//cdn.vision.qq.com/prod/imgs/static/static_1610961697306.jpg",
                    "hotAreas": []
                },
                "style": {},
                "commonStyle": {
                    "maxWidth": "100%",
                    "margin": "0px auto 0px auto",
                    "cursor": "default",
                    "border": "1px none #161616"
                },
                "wrapperStyle": {
                    "backgroundColor": "transparent",
                    "backgroundRepeat": "repeat-y",
                    "backgroundSize": "auto",
                    "backgroundPosition": "center top"
                },
                "fixedWrapperStyle": {},
                "actions": []
            },
            {
                "key": 7,
                "component": components['5'],
                "data": {
                    "src": "//cdn.vision.qq.com/prod/imgs/static/static_1610961719064.gif",
                    "hotAreas": []
                },
                "style": {},
                "commonStyle": {
                    "maxWidth": "100%",
                    "margin": "0px auto 0px auto",
                    "cursor": "default",
                    "border": "1px none #161616"
                },
                "wrapperStyle": {
                    "backgroundColor": "transparent",
                    "backgroundRepeat": "repeat-y",
                    "backgroundSize": "auto",
                    "backgroundPosition": "center top"
                },
                "fixedWrapperStyle": {},
                "actions": []
            },
            {
                "key": 8,
                "component": components['5'],
                "data": {
                    "src": "//cdn.vision.qq.com/prod/imgs/static/static_1610961757761.jpg",
                    "hotAreas": []
                },
                "style": {},
                "commonStyle": {
                    "maxWidth": "100%",
                    "margin": "0px auto 0px auto",
                    "cursor": "default",
                    "border": "1px none #161616"
                },
                "wrapperStyle": {
                    "backgroundColor": "transparent",
                    "backgroundRepeat": "repeat-y",
                    "backgroundSize": "auto",
                    "backgroundPosition": "center top"
                },
                "fixedWrapperStyle": {},
                "actions": []
            },
            {
                "key": 9,
                "component": components['5'],
                "data": {
                    "src": "//cdn.vision.qq.com/prod/imgs/static/static_1610961780557.gif",
                    "hotAreas": []
                },
                "style": {},
                "commonStyle": {
                    "maxWidth": "100%",
                    "margin": "0px auto 0px auto",
                    "cursor": "default",
                    "border": "1px none #161616"
                },
                "wrapperStyle": {
                    "backgroundColor": "transparent",
                    "backgroundRepeat": "repeat-y",
                    "backgroundSize": "auto",
                    "backgroundPosition": "center top"
                },
                "fixedWrapperStyle": {},
                "actions": []
            },
            {
                "key": 10,
                "component": components['5'],
                "data": {
                    "src": "//cdn.vision.qq.com/prod/imgs/static/static_1610961803378.jpg",
                    "hotAreas": []
                },
                "style": {},
                "commonStyle": {
                    "maxWidth": "100%",
                    "margin": "0px auto 0px auto",
                    "cursor": "default",
                    "border": "1px none #161616"
                },
                "wrapperStyle": {
                    "backgroundColor": "transparent",
                    "backgroundRepeat": "repeat-y",
                    "backgroundSize": "auto",
                    "backgroundPosition": "center top"
                },
                "fixedWrapperStyle": {},
                "actions": []
            },
            {
                "key": 11,
                "component": components['5'],
                "data": {
                    "src": "//cdn.vision.qq.com/prod/imgs/static/static_1610961825349.gif",
                    "hotAreas": []
                },
                "style": {},
                "commonStyle": {
                    "maxWidth": "100%",
                    "margin": "0px auto 0px auto",
                    "cursor": "default",
                    "border": "1px none #161616"
                },
                "wrapperStyle": {
                    "backgroundColor": "transparent",
                    "backgroundRepeat": "repeat-y",
                    "backgroundSize": "auto",
                    "backgroundPosition": "center top"
                },
                "fixedWrapperStyle": {},
                "actions": []
            },
            {
                "key": 12,
                "component": components['5'],
                "data": {
                    "src": "//cdn.vision.qq.com/prod/imgs/static/static_1610961847969.jpg",
                    "hotAreas": []
                },
                "style": {},
                "commonStyle": {
                    "maxWidth": "100%",
                    "margin": "0px auto 0px auto",
                    "cursor": "default",
                    "border": "1px none #161616"
                },
                "wrapperStyle": {
                    "backgroundColor": "transparent",
                    "backgroundRepeat": "repeat-y",
                    "backgroundSize": "auto",
                    "backgroundPosition": "center top"
                },
                "fixedWrapperStyle": {},
                "actions": []
            },
            {
                "key": 13,
                "component": components['5'],
                "data": {
                    "src": "//cdn.vision.qq.com/prod/imgs/static/static_1611113763297.gif",
                    "hotAreas": []
                },
                "style": {},
                "commonStyle": {
                    "maxWidth": "100%",
                    "margin": "0px auto 0px auto",
                    "cursor": "default",
                    "border": "1px none #161616"
                },
                "wrapperStyle": {
                    "backgroundColor": "transparent",
                    "backgroundRepeat": "repeat-y",
                    "backgroundSize": "auto",
                    "backgroundPosition": "center top"
                },
                "fixedWrapperStyle": {},
                "actions": []
            },
            {
                "key": 14,
                "component": components['5'],
                "data": {
                    "src": "//cdn.vision.qq.com/prod/imgs/static/static_1610961907941.jpg",
                    "hotAreas": []
                },
                "style": {},
                "commonStyle": {
                    "maxWidth": "100%",
                    "margin": "0px auto 0px auto",
                    "cursor": "default",
                    "border": "1px none #161616"
                },
                "wrapperStyle": {
                    "backgroundColor": "transparent",
                    "backgroundRepeat": "repeat-y",
                    "backgroundSize": "auto",
                    "backgroundPosition": "center top"
                },
                "fixedWrapperStyle": {},
                "actions": []
            },
            {
                "key": 15,
                "component": components['5'],
                "data": {
                    "src": "//cdn.vision.qq.com/prod/imgs/static/static_1610961971376.jpg",
                    "hotAreas": []
                },
                "style": {},
                "commonStyle": {
                    "maxWidth": "100%",
                    "margin": "0px auto 0px auto",
                    "cursor": "default",
                    "border": "1px none #161616"
                },
                "wrapperStyle": {
                    "backgroundColor": "transparent",
                    "backgroundRepeat": "repeat-y",
                    "backgroundSize": "auto",
                    "backgroundPosition": "center top"
                },
                "fixedWrapperStyle": {},
                "actions": []
            }
        ],
        "pluginInstances": [
            {
                "key": 17,
                "plugin": plugins['9'],
                "data": {
                    "maxWidth": 800
                }
            },
            {
                "key": 18,
                "plugin": plugins['5'],
                "data": {
                    "timeLineShowTitle": false,
                    "wording": "分享完成",
                    "icon": "//cdn.vision.qq.com/prod/imgs/static/static_1597464074778.png"
                }
            }
        ]
    }
};

export default function App({ version }) {
  const { componentInstances, pluginInstances } = selectVersion(instanceVersionMap, version);
  // Init
  initComponentInstanceIndexMap(componentInstances);

  return (
    <AppRender
      componentInstances={componentInstances}
      pluginInstances={pluginInstances}
      global={_global}
      meta={meta}
    />
  );
}

export function renderToString() {
  return ReactDOMServer.renderToString(<App />);
}
